import React, { useContext, useTransition } from "react";
import "../css/searchSortFilter.scss";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import CancelIcon from "@mui/icons-material/Cancel";
import { TodosContext } from "../providers/TodosProvider";
import TodoIndicators from "./TodoIndicators";
import { SlidersContext } from "../providers/SlidersProvider";
import { Switch } from "@mui/material";

const SearchSortFilterBar = ({ options, setOptions }) => {
  const { toggleTodosDrawer } = useContext(TodosContext);
  const { sliders, toggleSliders } = useContext(SlidersContext);

  let { searchTerm, primaryType } = options;

  function alterOptions(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "searchTerm" || name === "statusFilter") {
      window.sessionStorage.setItem(`${primaryType}_${name}`, e.target.value);
    }

    setOptions({ ...options, [name]: value });
  }

  return (
    <div className="searchSortFilterBar">
      <TodoIndicators />
      <div className="statusBarBlock"></div>
      <div className="primariesSearcher">
        <input
          onChange={alterOptions}
          value={searchTerm}
          type="text"
          placeholder="search"
          name="searchTerm"
          id="searchTerm"
        />

        <button
          onClick={() => {
            window.sessionStorage.setItem(`${primaryType}_searchTerm`, "");
            setOptions({ ...options, searchTerm: "" });
          }}
        >
          <CancelIcon className="icon" />
        </button>
      </div>

      <div className="slider-switch">
        <Switch
          inputProps={{ "aria-label": "Slider" }}
          checked={sliders}
          onChange={toggleSliders}
        />
      </div>

      <div className="sortAndFilterOptions">
        <button
          title="Notes"
          className="todos-btn"
          onClick={() => toggleTodosDrawer(true)}
        >
          {/* notes */}
          <PlaylistAddCheckIcon />
        </button>
      </div>
    </div>
  );
};

export default React.memo(SearchSortFilterBar);
